var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.558105C4.04481 0.558105 0 4.60292 0 9.55811C0 14.5133 4.04481 18.5581 9 18.5581C13.9552 18.5581 18 14.5133 18 9.55811C18 4.60292 13.9552 0.558105 9 0.558105ZM12.7632 12.7885C12.7632 13.0702 12.5121 13.3214 12.2303 13.3214H5.76955C5.4878 13.3214 5.23668 13.0702 5.23668 12.7885V6.32771C5.23668 6.04596 5.4878 5.79485 5.76955 5.79485H12.2303C12.5121 5.79485 12.7632 6.04597 12.7632 6.32771V12.7885Z",
    fill: "#D75E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationStopIcon);
export default __webpack_public_path__ + "static/media/operation-stop-icon.30a166b6c72886b137784eab04b84126.svg";
export { ForwardRef as ReactComponent };